import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var SearchAccountBalanceCtrl = function (fn, er, state, token, ids) {

	var config = {
		//crossDomain: true,
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},
	};
	var data = {
		month: state.selectedMonthYear,
		orderBy: "-date",
		page: state.currentPage,
		filter: state.search
	};

	axios
		.post(ApiConfig.url.SEARCH_ACCOUNT_BALANCE, data, config)
		.then(function (result) {
			fn(result.data)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { SearchAccountBalanceCtrl };